// Router guard, App boot yönlendirmesi (main.js) ve NB planı (Faz 5, AdminLayout.vue) arasında
// paylaşılan rota muafiyet mantığı — ayrı ayrı kopyalanırsa zamanla ayrışır. router.js'ten
// buraya taşındı (2026-09-14) ki AdminLayout.vue (router.js'i statik import eden bir dosya)
// döngüsel import'a girmeden bu listeyi okuyabilsin.
const PUBLIC_ROUTES = [
    '/anasayfa', '/auth/login', '/not-found', '/hata-erisim-yetkisi',
    '/oturum-suresi-bitti', '/randevusistemi/randevual', '/cagrisistemi/cagriolustur',
    '/onkayitform/onkayit', '/teklif/talepolustur',
    '/onkayit/onkayitform', '/cagrisistemi/cagriolustur',
    '/masaustunde-acin', // MOB M1-0 (K5): mobil uygulamada sağlayıcı
    '/yeni-surum-kurun', // MOB M1-1: eski mobil uygulama
    '/kayit', // SAT-4: self-servis hesap açma (hepy.app fiyat sayfasından)
];

export function esPublicYolMu(path, fullPath) {
    return PUBLIC_ROUTES.includes(path) ||
        path.startsWith('/sifreislemleri') ||
        path.startsWith('/onkayit') ||
        path.startsWith('/randevusistemi') ||
        path.startsWith('/cagrisistemi') ||
        path.startsWith('/public/teklif') ||
        path.startsWith('/katalog') ||
        path.startsWith('/genelyardimsayfasi') ||
        (fullPath || '').startsWith('blob:');
}

// Hata / zorunlu yönlendirme sayfaları — tek liste (GB §4.2): geriNavigasyon (geri butonu bu
// sayfalara "geri" dönmez) ve KDU guard'ı (bu hedeflere zorunlu yönlendirmede kaydedilmemiş
// değişiklik sorulmaz, plan V5) buradan okur.
export const HATA_YOLLARI = ['/hata-erisim-yetkisi', '/lisans-yok', '/oturum-suresi-bitti', '/not-found', '/masaustunde-acin', '/yeni-surum-kurun'];

// KDU V5: oturum bitti / yetki yok / lisans yok / bulunamadı ve login — sormadan geçilir (oturum
// zaten bitmiştir; sormak kullanıcıyı çıkışsız bırakır). Gönüllü Çıkış düğmesi layout'ta ayrıca sorar.
export function zorunluHedefMi(path) {
    const p = (path || '').toLowerCase();
    return HATA_YOLLARI.includes(p) || p === '/auth/login';
}

// NB planı Faz 5 (navbar yetki tazeleme) + ileride GB1'in geriGit'i: tazeleme sonrası mevcut
// rota için yeniden yetki kontrolü yapılmaması/yönlendirilmemesi gereken yollar — ya döngü
// riski taşır (/hata-erisim-yetkisi bizzat, esPublicYolMu ile zaten muaf) ya da menüde
// görünmeyen ama erişilebilir sayfalardır (MenudeGoster=0, ör. /kullanici/ayarlar DEĞİL —
// o sayfa GetYetkiKontrol'den geçer; asıl muaf olması gerekenler guard'ın kendisinin de
// yetkiGerekli=false saydığı yollar (yetkiKontroluMuafMi: /yardim/genelyardimsayfasi, /sparqon)
// ve lisans kapısının kendisi /lisans-yok).
export function yetkiYenidenKontrolMuafMi(path, fullPath) {
    return esPublicYolMu(path, fullPath) ||
        path === '/lisans-yok' ||
        yetkiKontroluMuafMi(path);
}

// SPQ1: sayfa yetkisi (GetYetkiKontrol) hiç sorulmayan korumalı yollar — router guard (yetkiGerekli)
// ve AdminLayout NB Faz 5 yeniden kontrolü (yukarıda) bu tek listeyi okur. /sparqon: T3, Sparqon
// lisansıyla korunur (WebSayfa kaydı yok, 2026-09-25 kararı). Sondaki / atılır.
export function yetkiKontroluMuafMi(path) {
    const p = (path || '').toLowerCase().replace(/\/+$/, '');
    return p.startsWith('/yardim/genelyardimsayfasi') || p === '/sparqon';
}
